import React, { useEffect, useState } from "react";
import AppButton from "../AppButton/AppButton";
import google from "../../assets/icons/google.svg";
import apple from "../../assets/icons/apple.svg";

interface AppDownloadProps {
  center?: boolean;
}

const AppDownload: React.FC<AppDownloadProps> = ({ center = false }) => {
  const [deviceType, setDeviceType] = useState("");

  useEffect(() => {
    const detectDevice = () => {
      const userAgent = navigator.userAgent;

      if (/android/i.test(userAgent)) {
        setDeviceType("Android");
      } else if (/iPad|iPhone|iPod/.test(userAgent)) {
        setDeviceType("iOS");
      } else {
        setDeviceType("Other");
      }
    };

    detectDevice();
  }, []);

  const handleAppStoreClick = () => {
    window.location.href =
      "https://itunes.apple.com/app/cora/id6587574644?mt=8";
  };

  const handleGooglePlayClick = () => {
    window.location.href =
      "https://play.google.com/store/apps/details?id=com.dawnhealth.corabc";
  };

  return (
    <div
      className="flex flex-col gap-2 w-full"
      style={{ alignItems: center ? "center" : "start" }}
    >
      {(deviceType === "iOS" || deviceType === "Other") && (
        <AppButton
          style={{
            maxWidth: "264px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
          }}
          onClick={handleAppStoreClick}
        >
          <img src={apple} alt="App store icon" />
          App Store
        </AppButton>
      )}
      {(deviceType === "Android" || deviceType === "Other") && (
        <AppButton
          style={{
            maxWidth: "264px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
          }}
          onClick={handleGooglePlayClick}
        >
          <img src={google} alt="Google play icon" />
          Google Play
        </AppButton>
      )}
    </div>
  );
};

export default AppDownload;
